import React from "react";

import PropTypes from 'prop-types';
import { makeStyles, lighten } from '@material-ui/core';
import SvgIcon from "../../../Helpers/Svg/SvgIcon";
import "./PromotedProduct.scss";

export default function PromotedProduct({icon, title, subTitle, buttonText, hasBackgroundImage, backgroundImage, ctaType, redirectUri, filter, handlePromotedProduct}) {

  const useStyles = makeStyles(theme => ({
    primaryColor: {
      color: theme.palette.primary.main
    },
    PromotedProductBackgroundImage: {
      backgroundImage: (backgroundImage ? `url(${backgroundImage})` : "url(/Tools/perm_banner.jpg)"),
    },
    PromotedProductBackgroundColor: {
      backgroundColor: lighten(theme.palette.primary.main, 0.95),
    },
  }));

  const classes = useStyles();

  return (
    <button 
      className={`promoted-product ${hasBackgroundImage ? classes.PromotedProductBackgroundImage + " has-bg-image" : classes.PromotedProductBackgroundColor}`} 
      onClick={() => handlePromotedProduct(ctaType, filter, redirectUri)}>
      <div className="content-group">
        <div className="icon-container">
          <SvgIcon iconName={icon} className={`${hasBackgroundImage ? "" : classes.primaryColor}`} />
        </div>
        <h3>{title}</h3>
        <p>{subTitle}</p>
      </div>
      <label className={`${hasBackgroundImage ? "" : classes.primaryColor}`}>{buttonText}</label>
    </button>
  );
}

PromotedProduct.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string,
  ctaType: PropTypes.string.isRequired,
  redirectUri: PropTypes.string,
  filter: PropTypes.string,
  handlePromotedProduct: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/CtaSolution/PromotedProduct.js